export enum LifeLineItemType {
  LAB_VALUE = "hl7_fhir_r4_lab_value"
}
